import React, { FC } from 'react'
import { graphql } from 'gatsby'
import { CTALast, CTALastProps } from '@mode/components'

export const HomeCtaLast: FC<CTALastProps> = (props) => {
  return (
    <CTALast {...props} />
  )
}
